module.exports = __webpack_public_path__ + "5ec371aad32795d273134bb95e41c4f3.MP3";